import {
  readableRadioTextOperations,
  RadioTextFilterOperation,
} from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { BasicListOption } from '../GenericBloc/GenericLargeListFilter/GenericLargeListType';

export const URL_OPERATION_OPTION_LIST: BasicListOption<RadioTextFilterOperation>[] = [
  RadioTextFilterOperation.CONTAINS,
  RadioTextFilterOperation.STARTS_WITH,
  RadioTextFilterOperation.ENDS_WITH,
  RadioTextFilterOperation.IS_EXACTLY,
  RadioTextFilterOperation.IS,
  RadioTextFilterOperation.REGEX,
].map((item) => ({
  value: item,
  label: readableRadioTextOperations[item],
}));

export const TEXT_OPERATION_OPTION_LIST: BasicListOption<RadioTextFilterOperation>[] = [
  RadioTextFilterOperation.CONTAINS,
  RadioTextFilterOperation.IS,
  RadioTextFilterOperation.IS_NOT,
  RadioTextFilterOperation.NOT_CONTAINS,
].map((item) => ({
  value: item,
  label: readableRadioTextOperations[item],
}));

export const FUNNEL_STEP_TEXT_OPERATION_OPTION_LIST: BasicListOption<RadioTextFilterOperation>[] = [
  RadioTextFilterOperation.CONTAINS,
  RadioTextFilterOperation.IS,
].map((item) => ({
  value: item,
  label: readableRadioTextOperations[item],
}));
